<template>
  <div>
    <van-popup v-model="visible" position="bottom">
      <div class="repayment-select">
        <img
          class="close"
          src="https://static.ndmicro.com/tmd/landing/images/btn_close.png"
          srcset="
                    https://static.ndmicro.com/tmd/landing/images/btn_close@2x.png 2x,
                    https://static.ndmicro.com/tmd/landing/images/btn_close@3x.png 3x
                "
          @click="close"
        />
        <div class="panel">
          <div class="cell-title">
            账单总额 (元)
            <span style="font-family: DIN-Medium,DIN;">{{
              totalAmount | currency
            }}</span>
          </div>

          <div class="term-list">
            <table width="100%">
              <tr class="table-header">
                <th width="5%"></th>
                <th width="15%">期数</th>
                <th width="25%">支付日</th>
                <th width="20%">应付金额</th>
                <th width="20%">实付金额</th>
                <th width="15%">状态</th>
              </tr>

              <tr
                class="table-row"
                v-for="(item, index) in canRepayList"
                :key="index"
                @click="selectTerm(index, item)"
              >
                <td>
                  <div
                    :class="[
                      'select',
                      selectedTerm.includes(index) &&
                        'selected'
                    ]"
                  >
                  </div>
                </td>
                <td>
                  {{ item.termNo }}/{{
                    scheduleList.length
                  }}期
                </td>
                <td>
                  {{ item.pmtDueDate | date('YYYY/MM/DD') }}
                </td>
                
                <td>
                  <div>
                    <span>{{
                      item.schdLoanServFee | currency
                    }}</span>
                  </div>
                </td>
                <td >
                  <div>
                    <span>{{
                      item.paidLoanServFee | currency
                    }}</span>
                  </div>
                </td>
                <td
                  class="status"
                  :class="item.rightRepayStatus.toLowerCase()"
                >
                  {{ item.rightRepayStatus | status }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="footer">
          <nd-button
            :disabled="selectedTerm.length === 0"
            @click="goRepayment"
          >下一步</nd-button>
        </div>
      </div>
    </van-popup>
    
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'repayment-select',
  customReadyNotify: true,
  props: {
    scheduleList: { type: Array, default: () => [] },
    loanPlatform: { type: String },
    billNo: { type: String },
    fundCode: { type: String },
    productCd: { type: String },
    canOffLineRepay: { type: Boolean, default: true },
    termNo: { type: Number },
    canOnlyRepayAll: { type: Boolean, default: true },
    canConsultRepay: { type: Boolean, default: false }
  },

  data () {
    return {
      visible: false,
      selectedTerm: [],
      overdueVisible: false,
      prepayVisible: false,
      popItem: {},
      
      payStatusInfo: {},
      pending: false
    }
  },

  filters: {
    status (value) {
      const mapping = {
        U: '未支付',
        S: '已支付',
        P: '支付中',
        O: '已超期',
        C: '已关闭'
      }
      return mapping[value]
    }
  },

  computed: {
    totalAmount () {
      return this.selectedTerm.reduce(
        (a, b) => a + this.canRepayList[b].schdLoanServFee,
        0
      )
    },

    // 可选列表
    canRepayList () {
      return this.scheduleList.filter(item => ['U', 'O'].includes(item.rightRepayStatus))
    }
  },
  destroyed () {
    this.$storage.remove('repaySvipDialog')
  },
  methods: {
    ...mapActions('repay', ['consumptionRepayTrialX']),
    ...mapActions('vip', [
      'orderList'
    ]),
    open () {
      this.visible = true
    },
   

    close () {
      this.visible = false
    },

    getRepayTrial () {
      const params = {
        billNo: this.billNo,
        terms: this.selectedTerm.map(item => {
          return this.canRepayList[item].termNo
        })
      }
      return this.consumptionRepayTrialX(params)
    },

    // 选择期数
    selectTerm (index, term) {
      const canList = []
      this.canRepayList.map((item, idx) => {
        if (!this.selectedTerm.includes(idx)) {
          canList.push(idx)
        }
      })
      // canOnlyRepayAll 'true' 代表只能提前结清
      if (this.selectedTerm.includes(index)) {
        // 如果取消的不是当期，并且只支持提前结清，如果没有逾期, 那么就默认选中当期
        if (
          term.repaymentIndex > this.termNo &&
          this.canOnlyRepayAll
        ) {
          this.selectAll()
        } else {
          if (Math.max(...this.selectedTerm) === index) {
            this.toggle(this.selectedTerm, index)
          } else {
            this.$message('请顺次选择还款期数')
          }
        }
      } else {
        // 如果选择的不是当期，并且只支持提前结清，那就直接全选
        // console.log(term, this.termNo, this.canOnlyRepayAll)
        if (
          term.repaymentIndex > this.termNo &&
          this.canOnlyRepayAll
        ) {
          this.selectAll()
          this.$message('根据借款方要求，当前仅支持提前整笔结清')
        } else {
          if (Math.min(...canList) === index) {
            this.toggle(this.selectedTerm, index)
          } else {
            this.$message('请顺次选择还款期数')
          }
        }
      }
    },

    toggle (arr, i) {
      const index = arr.indexOf(i)
      if (index === -1) {
        arr.push(i)
      } else {
        arr.splice(index, 1)
      }
      return arr
    },

    selectAll () {
      if (this.selectedTerm.length === this.canRepayList.length) {
        const selectedTerm = []
        this.selectedTerm = selectedTerm
      } else {
        this.selectedTerm = this.canRepayList.map((item, idx) => idx)
      }
    },

    // 查看逾期还款详情
    overdueRepaymentInfo (item) {
      this.popItem = item
      this.overdueVisible = true
    },

    async goRepayment () {
      this.jump()
    },
    async jump () {
      this.$storage.set(
        'selectedTerms',
        this.selectedTerm.map((item) => this.canRepayList[item])
      )
      if (this.pending) return
      this.pending = true
      const response = await this.getRepayTrial()
      setTimeout(() => {
        this.pending = false
      }, 300)
      if (response.success) {
        this.$storage.set('trail', response.data)
        this.$router.push({
          path: '/repayment/confirm-expense',
          query: {
            billNo: this.billNo,
            fundCode: response.data.fundCode, 
            termId: this.canRepayList[this.selectedTerm[0]].termId
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.van-popup {
    background-color: transparent;
}
.repayment-select {
    position: relative;
    background-color: #fff;
    border-radius: 30px 30px 0 0;
    .close {
        position: absolute;
        width: 33px;
        height: 33px;
        top: 60px;
        right: 50px;
    }

    .panel {
        padding: 0 30px;
        overflow: hidden;

        .cell-title {
            font-size: 32px;
            margin-top: 60px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            line-height: 50px;
        }

        .term-list {
            margin-top: 83px;
            height: 768px;
            overflow-y: scroll;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 50px;
                    }
                }

                .table-row {
                    td {
                        height: 110px;
                        line-height: 110px;
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        text-align: center;
                        vertical-align: middle;

                        .select {
                            width: 32px;
                            height: 32px;
                            background-size: cover;
                            background-image: url(../images/unselected.png);

                            &.selected {
                                background-image: url(../images/selected.png);
                            }

                            &.disabled {
                                background-image: none;
                                background-color: #dddddd;
                                border-radius: 32px;
                            }
                        }
                    }

                    .status {
                        &.o {
                            color: @fc-error;
                        }
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }

                    .amount {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;

                        .amount-wrapper {
                            position: relative;

                            .wavamount {
                                transform: translate3d(-50%, -50%, 0);
                                position: absolute;
                                top: 80%;
                                left: 50%;
                                text-decoration: line-through;
                                color: @fc4;
                            }
                        }

                        img {
                            width: 23px;
                            height: 23px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
    }

    .footer {
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
        overflow: hidden;
        > button {
            display: block;
            margin: 30px auto 58px;
        }
    }

    .overdue-repayemnt-info,
    .prepay-rule {
        padding: 0 45px;
        padding-bottom: 37px;

        .title {
            height: 72px;
            line-height: 72px;
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }

        .divide {
            height: 32px;
            line-height: 32px;
            font-size: 28px;
            margin-top: 23px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }

        .amount {
            font-size: 32px;
            height: 32px;
            line-height: 32px;
            margin-top: 27px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: @fc1;

            &.overdue {
                color: @theme;
            }

            em {
                font-size: 22px;
                padding-left: 10px;
                display: inline-block;
                font-style: normal;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: @fc4;
                text-decoration: line-through;
            }
        }

        .explain {
            font-size: 22px;
            height: 44px;
            line-height: 44px;
            margin-top: 3px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc4;
            text-align: left;
        }

        .principal,
        .interest {
            margin-top: 15px;
            height: 40px;
            line-height: 40px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }

        p {
            font-size: 24px;
            line-height: 33px;
            margin-top: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }
    }
}
</style>